module.exports = __webpack_public_path__ + "static/media/uapay.00c1c7b4.svg";